appSocial.controller('leaderDetailsPage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'trader', 'SocialActionService',
    'SocialTypes', 'SocialFavoriteService', 'LeadersCompareService',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, trader, SocialActionService,
              SocialTypes, SocialFavoriteService, LeadersCompareService) {

        const {CopyAction} = SocialTypes;

        class LeaderDetailsPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                /**
                 * @type {Trader}
                 */
                this.trader = trader;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;

                /**
                 * @type {LeadersCompareService}
                 */
                this.compareService = LeadersCompareService;

                this.types = SocialTypes;
                this.action = CopyAction;

                this.contextMenuConfig = {
                    top: (menu) => {
                        return '35px';
                    },
                }
            }

            /**
             * @param {Trader} trader
             * @return {*}
             */
            copy(trader) {
                const {CopyAction} = this.types;
                if (trader.isFollowed) {
                    return this.utils.navigate('root.app.socialFunds', {id: trader.id, action: CopyAction.AddFunds})
                }

                this.actionService.stateCheck({trader, action: CopyAction.StartCopy})
            }

            toggleFavorite() {
                this.favoriteService.toggleFavorite(this.trader);
            }

            /**
             * @param {CopyAction} action
             */
            callAction(action) {
                return this.actionService.callAction(action, this.trader);
            }

            compare() {
                if (!this.compareService.isTraderComparing(this.trader) && !this.compareService.limitReached) {
                    if (!this.compareService.isComparing) {
                        this.compareService.enableSelection();
                    }
                    this.compareService.add(this.trader);
                }
                this.utils.navigate('root.app.socialCompare');
            }
        }

        return new LeaderDetailsPage()
    }]);

